import React from 'react';
import './index.scss';
import { reviewsFormat } from '@op/utils/value';
import { getLocale, useIntl } from 'umi';
import { NO_DATE } from '@op/constants';
import { getLanguage } from '@home/utils/common';
import { LANGUAGE_EN } from '@home/_config/config';
import classNames from 'classnames';

const moduleTitleMap: any = {
  game_store: '# of Selected Positive Reviews',
  game_store_techland: 'Starred Positive Reviews',
  community: {
    all: '# of Mentions',
    posts: '# of Mentions',
    video: '# of Video Engagement',
    streaming: '# of Hours Watched',
  },
  accounts: '# of Followers',
  news: '# of Articles',
  google_trends: 'Peak Index',
  influencers: '# of Influencers',
};

const rankName = ['st', 'nd', 'rd', 'th'];

export default function TrendCardTips({
  moduleType,
  rankList,
  communityType,
  isLeft = false,
  formatValue = reviewsFormat,
  currentRank = 0
}: any) {
  const { formatMessage } = useIntl();
  const isEn = getLocale() === LANGUAGE_EN;
  let item = moduleTitleMap[moduleType];
  if (communityType) {
    item = item?.[communityType];
  }

  return (
    <div
      className={`dbh-trend-cardtips ${isLeft && 'dbh-trend-cardtips--left'}`}
    >
      <div className="dbh-trend-cardtips-header">
        <div className="dbh-trend-cardtips-th  dbh-trend-cardtips-th-rank">
          {formatMessage({ id: 'Rank' })}
        </div>
        <div className="dbh-trend-cardtips-th  dbh-trend-cardtips-th-img">
          {formatMessage({ id: 'Game' })}
        </div>
        <div className="dbh-trend-cardtips-th  dbh-trend-cardtips-th-name">
          {/* 游戏名称 */}
        </div>
        <div className="dbh-trend-cardtips-th  dbh-trend-cardtips-th-num">
          {formatMessage({ id: item || NO_DATE.EMPTY })}
        </div>
      </div>
      <div className="dbh-trend-cardtips-body">
        <div className="dbh-trend-cardtips-list">
          {rankList.map(
            (
              item: {
                edition_unified_id: string;
                cover: string | undefined;
                value: number;
                entity_name_en: string;
                entity_name_cn: string;
                entity_name: string;
              },
              index: number,
            ) => {
              const { edition_unified_id: id, cover, value, entity_name: name, entity_name_en: nameEn, entity_name_cn: nameCn } = item || {};
              return (
                <div
                  className={
                    classNames("dbh-trend-cardtips-item",{
                      'dbh-trend-cardtips-item-active': currentRank === index
                    })
                  }
                  key={id}
                >
                  <div className="dbh-trend-cardtips-td dbh-trend-cardtips-td-rank">
                    {index + 1}{rankName[index] || 'th'}
                  </div>
                  <div className="dbh-trend-cardtips-td dbh-trend-cardtips-td-img">
                    <img src={cover} />
                  </div>
                  <div className="dbh-trend-cardtips-td dbh-trend-cardtips-td-name">
                    {getLanguage(isEn, nameEn || name, nameCn || name) || '-' }
                  </div>
                  <div className="dbh-trend-cardtips-td dbh-trend-cardtips-td-num">
                    {formatValue(value)}
                  </div>
                </div>
              );
            },
          )}
        </div>
      </div>
    </div>
  );
}
